const Routes = {
  login: "/",
  welcome: "/welcome",
  preferences: "/preferences",
  movies: "/movies",
  favorites: "/favorites",
  generationType: "/generation-type",
  contact: "/contact",
  terms: "/terms",
  movieNews: "/movie-news",

  testTMDB: "/test-tmdb", //for testing TMDb api from frontend
}

export default Routes;